import {
  ReadOnlyBlockfrostProvider,
  WalletObserverProvider,
} from "@sundaeswap/wallet-lite";
import { TooltipProvider } from "@sundaeswap/ui-toolkit";
import { FC, PropsWithChildren } from "react";

import { AppContextProvider } from "@/context/AppContext";
import { GummiwormProvider } from "@/context/GummiwormContext";
import { SetupBlazeProvider } from "./SetupBlazeProvider";

interface IWalletMetadata {
  assetId: string;
  decimals: number;
  name: string;
}

export const ProvidersWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <WalletObserverProvider
      options={{
        refreshInterval: 10_000,
        observerOptions: {
          persistence: true,
          readOnlyProvider: window.__APP_CONFIG.blockfrostProjectId
            ? new ReadOnlyBlockfrostProvider(
                window.__APP_CONFIG.blockfrostProjectId,
              )
            : undefined,
          metadataResolver: async ({
            assetIds,
            normalizeAssetId,
            isAdaAsset,
          }) => {
            const metadataMap = new Map<string, IWalletMetadata>();

            assetIds.forEach((id) => {
              const hexName = id.split(".")?.[1] ?? "";
              const assetName = isAdaAsset(id)
                ? "ADA"
                : Buffer.from(hexName, "hex").toString("utf-8");

              metadataMap.set(normalizeAssetId(id), {
                assetId: normalizeAssetId(id),
                decimals: 6,
                name: assetName,
              });
            });

            return metadataMap;
          },
        },
      }}
    >
      <AppContextProvider>
        <GummiwormProvider>
          <SetupBlazeProvider>
            <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
          </SetupBlazeProvider>
        </GummiwormProvider>
      </AppContextProvider>
    </WalletObserverProvider>
  );
};
